export function iDateToIsoDate(d: string) {
  return `${d.substring(0, 4)}-${d.substring(4, 6)}-${d.substring(6, 8)}`;
}

export function isoDateToIDate(d: string) {
  return `${d.substring(0, 4)}${d.substring(5, 7)}${d.substring(8, 10)}`;
}

export function isoDateTimeToIDateTime(d: string) {
  return `${d.substring(0, 4)}${d.substring(5, 7)}${d.substring(8, 10)}T${d.substring(11, 13)}${d.substring(14, 16)}${d.substring(17, 19) || "00"}`;
}

export function iDateToIsoDateTime(d: string) {
  if (d.length === 8) {
    return `${d.substring(0, 4)}-${d.substring(4, 6)}-${d.substring(6, 8)}T00:00:00`;
  }

  return `${d.substring(0, 4)}-${d.substring(4, 6)}-${d.substring(6, 11)}:${d.substring(11, 13)}:${d.substring(13, 16)}`;
}

export function pad(num: number) {
  return (num < 10 ? "0" : "") + num;
}

export function jsDateToLocalIDate(d: Date) {
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
}

export function jsDateToLocalIDateTime(d: Date) {
  return `${jsDateToLocalIDate(d)}T${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

export function jsDateToLocalIsoDate(d: Date) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function jsDateToLocalIsoDateTime(d: Date) {
  return `${jsDateToLocalIsoDate(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function iDateLocal(d: string) {
  return jsDateToLocalIDate(new Date(iDateToIsoDateTime(d)));
}

export function iDateTimeLocal(d: string) {
  return jsDateToLocalIDateTime(new Date(iDateToIsoDateTime(d)));
}

export function nextHalfHour(d: Date) {
  const d2 = new Date(d);
  d2.setMinutes(Math.floor(d.getMinutes() / 30) * 30 + 30);
  return d2;
}
